<template>
  <div class="content-wrapper">
    <div class="bg-content"></div>
    <div class="relative content-cards">
      <DetailCard>
        <template #title>Chie's Easy Peasy Japanesey</template>
        <template #content>
          <div class="card-wrapper">
            <v-layout wrap justify-center>
              <v-flex v-for="(item, key) in cardItems" :key="key" lg4 xs12 px-2 mt-4 mt-lg-0>
                <div class="card-title">{{ item.title }}</div>
                <picture>
                  <source :srcset="item.webpSrc" type="image/webp" />
                  <source :srcset="item.pngSrc" type="image/png" />
                  <img :src="item.pngSrc" class="card-img" alt="[Item]" />
                </picture>
                <div class="card-text d-block d-lg-none">{{ item.text }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center d-none d-lg-flex>
              <v-flex v-for="(item, key) in cardItems" :key="key" xs4 px-2>
                <div class="card-text fill-height">{{ item.text }}</div>
              </v-flex>
            </v-layout>
            <div class="text-center d-none d-md-block">
              <picture>
                <source :srcset="`${schedulePath}.webp`" type="image/webp" />
                <source :srcset="`${schedulePath}.png`" type="image/png" />
                <img :src="`${schedulePath}.png`" alt="[Lesson]" class="schedule-img" />
              </picture>
            </div>
            <div class="text-right d-block d-md-none">
              <picture>
                <source :srcset="`${schedulePath}SP.webp`" type="image/webp" />
                <source :srcset="`${schedulePath}SP.png`" type="image/png" />
                <img :src="`${schedulePath}SP.png`" alt="[Lesson]" class="schedule-img" />
              </picture>
            </div>
          </div>
        </template>
      </DetailCard>

      <DetailCard class="credit-input-card">
        <template #title>{{ $t('fellowship.payment.register-credit-title') }}</template>
        <template #content>
          <slot name="inputs" />
        </template>
      </DetailCard>
    </div>
  </div>
</template>

<script>
import DetailCard from './DetailCard';

export default {
  components: {
    DetailCard,
  },
  data() {
    return {
      cardItems: [
        {
          title: '1 hour Lesson/week',
          pngSrc: '/img/programs/fellowship/chie/lpImageValue1.png',
          webpSrc: '/img/programs/fellowship/chie/lpImageValue1.webp',
          text:
            'Every Saturday either from 10:00 ~ 11:00 or 11:00 ~ 12:00 GMT, a lesson with max 5 students for 1 hour is held.',
        },
        {
          title: 'Community Matching',
          pngSrc: '/img/programs/fellowship/lpImageValue2.png',
          webpSrc: '/img/programs/fellowship/lpImageValue2.webp',
          text: 'You can access anytime to a community space to talk with other Japanese learners',
        },
        {
          title: 'All fondi function',
          pngSrc: '/img/programs/fellowship/lpImageValue3.png',
          webpSrc: '/img/programs/fellowship/lpImageValue3.webp',
          text:
            'All functions of fondi worth 19 USD to meet up with international friends in English or Japanese are unlocked for all students!',
        },
      ],
    };
  },
  computed: {
    schedulePath() {
      return '/img/programs/fellowship/chie/lpLessonSchedule';
    },
  },
};
</script>

<style scoped>
.content-wrapper {
  position: relative;
  overflow: hidden;
  margin-top: 224px;
  padding: 270px 0;
}
.bg-content {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 200vw;
  left: -50vw;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  background-image: url('/img/lp/patterns/slashLight.png');
  background-repeat: repeat;
  border-top: solid rgb(242, 231, 202) 8px;
}
.content-cards {
  padding: 0 10%;
}
.card-wrapper {
  padding: 80px 100px 48px;
}
.card-title {
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  padding: 6px 0 10px;
  text-align: center;
  background-repeat: round;
  background-image: url(/img/lp/IpFrmValueTitle.png);
}
.card-img {
  width: 100%;
}
.card-text {
  border-radius: 2px;
  background-color: #ebebeb;
  font-size: 22px;
  line-height: 1.2em;
  font-weight: bold;
  color: #717171;
  padding: 16px 12px;
}
.schedule-img {
  margin-top: 48px;
  width: 100%;
}
.credit-input-card {
  margin-top: 150px;
}
@media (max-width: 1263px) {
  .card-wrapper {
    padding: 0px 40px 48px;
  }
  .card-title {
    font-size: 0.9em;
  }
  .card-text {
    font-size: 0.8em;
    padding: 4px 6px;
    margin-top: -3px;
  }
}
@media (max-width: 767px) {
  .content-cards {
    padding: 0 20px;
  }
  .content-wrapper {
    margin-top: 60px;
    padding: 60px 0 40px;
  }
  .bg-content {
    width: 400vw;
    left: -150vw;
  }
  .schedule-img {
    width: 90%;
  }
  .credit-input-card {
    margin-top: 50px;
  }
}
</style>
